import React from 'react';

const Step4Experience = ({
  formData,
  formErrors,
  handleExperienceTypeChange,
  handleExperienceChange,
  addExperience,
  removeExperience,
  handleExperienceFileUpload,
  handleRemoveExperienceFile,
  isSubmitting,
  isOtpStep,
  handleChange
}) => {
  return (
    <>

      <div className="experience-section">
        {/* Experience Type Selection */}
        <div className="experience-type-section full-width">
          <div className="application-field" style={{ maxWidth: '400px' }}>
            <label htmlFor="experienceType">Are you a Fresher or Experienced? <span className="required-star">*</span></label>
            <select
              id="experienceType"
              value={formData.experienceType || ''}
              onChange={(e) => handleExperienceTypeChange(e.target.value)}
              disabled={isSubmitting}
            >
              <option value="">Select</option>
              <option value="fresher">Fresher</option>
              <option value="experienced">Experienced</option>
            </select>
            {formErrors.experienceType && (
              <p className="application-error">{formErrors.experienceType}</p>
            )}
          </div>
        </div>

        {/* Experience Details - Only show if Experienced */}
        {formData.experienceType === 'experienced' && (
          <>
            {formData.experienceList.map((exp, index) => (
              <div key={exp.id} className="experience-entry">
                <div className="experience-header">
                  <h4>Experience #{index + 1}</h4>
                  {formData.experienceList.length > 1 && (
                    <button
                      type="button"
                      className="remove-experience-btn"
                      onClick={() => removeExperience(index)}
                      disabled={isSubmitting}
                    >
                      ✕ Remove
                    </button>
                  )}
                </div>

                <div className="experience-fields">
                  <div className="application-field">
                    <label htmlFor={`companyName-${index}`}>Company Name <span className="required-star">*</span></label>
                    <input
                      id={`companyName-${index}`}
                      value={exp.companyName || ''}
                      onChange={(e) => handleExperienceChange(index, 'companyName', e.target.value)}
                      placeholder="Enter company name"
                      disabled={isSubmitting}
                    />
                    {formErrors.experienceList?.[index]?.companyName && (
                      <p className="application-error">{formErrors.experienceList[index].companyName}</p>
                    )}
                  </div>

                  <div className="application-field">
                    <label htmlFor={`designation-${index}`}>Designation <span className="required-star">*</span></label>
                    <input
                      id={`designation-${index}`}
                      value={exp.designation || ''}
                      onChange={(e) => handleExperienceChange(index, 'designation', e.target.value)}
                      placeholder="Enter your designation"
                      disabled={isSubmitting}
                    />
                    {formErrors.experienceList?.[index]?.designation && (
                      <p className="application-error">{formErrors.experienceList[index].designation}</p>
                    )}
                  </div>

                  <div className="application-field">
                    <label htmlFor={`employmentType-${index}`}>Employment Type <span className="required-star">*</span></label>
                    <select
                      id={`employmentType-${index}`}
                      value={exp.employmentType || ''}
                      onChange={(e) => handleExperienceChange(index, 'employmentType', e.target.value)}
                      disabled={isSubmitting}
                    >
                      <option value="">Select Employment Type</option>
                      <option value="Full Time">Full Time</option>
                      <option value="Part Time">Part Time</option>
                      <option value="Contract">Contract</option>
                      <option value="Internship">Internship</option>
                      <option value="Freelance">Freelance</option>
                    </select>
                    {formErrors.experienceList?.[index]?.employmentType && (
                      <p className="application-error">{formErrors.experienceList[index].employmentType}</p>
                    )}
                  </div>

                  <div className="application-field">
                    <label htmlFor={`startDate-${index}`}>Start Date <span className="required-star">*</span></label>
                    <input
                      id={`startDate-${index}`}
                      type="date"
                      value={exp.startDate || ''}
                      onChange={(e) => handleExperienceChange(index, 'startDate', e.target.value)}
                      disabled={isSubmitting}
                    />
                    {formErrors.experienceList?.[index]?.startDate && (
                      <p className="application-error">{formErrors.experienceList[index].startDate}</p>
                    )}
                  </div>

                  <div className="application-field">
                    <label htmlFor={`endDate-${index}`}>End Date {!exp.currentlyWorking && <span className="required-star">*</span>}</label>
                    <input
                      id={`endDate-${index}`}
                      type="date"
                      value={exp.endDate || ''}
                      onChange={(e) => handleExperienceChange(index, 'endDate', e.target.value)}
                      disabled={isSubmitting || exp.currentlyWorking}
                    />
                    {formErrors.experienceList?.[index]?.endDate && (
                      <p className="application-error">{formErrors.experienceList[index].endDate}</p>
                    )}
                  </div>

                  <div className="application-field checkbox-field full-width">
                    <label>
                      <input
                        type="checkbox"
                        checked={exp.currentlyWorking || false}
                        onChange={(e) => handleExperienceChange(index, 'currentlyWorking', e.target.checked)}
                        disabled={isSubmitting}
                      />
                      I currently work here
                    </label>
                  </div>
                </div>

                {/* Upload Experience Certificate */}
                <div className="upload-documents-section full-width">
                  <h5>Upload Experience Certificate</h5>
                  <div className="upload-row">
                    <div className="application-field">
                      <div className={`upload-area ${exp.experienceCertificate ? 'has-file' : ''}`}>
                        <input
                          id={`experienceCert-${index}`}
                          type="file"
                          accept=".jpg,.jpeg,.png,.pdf"
                          onChange={(e) => handleExperienceFileUpload(index, e)}
                          disabled={isSubmitting}
                        />
                        {exp.experienceCertificate ? (
                          <div className="file-selected">
                            <span className="file-name">📄 {exp.experienceCertificate}</span>
                            <div className="file-actions">
                              <button
                                type="button"
                                className="update-file"
                                onClick={() => { document.getElementById(`experienceCert-${index}`).click(); }}
                              >
                                Update
                              </button>
                              <button
                                type="button"
                                className="remove-file"
                                onClick={() => handleRemoveExperienceFile(index)}
                              >
                                ✕
                              </button>
                            </div>
                          </div>
                        ) : (
                          <>
                            <p>Click or Drag file to upload</p>
                            <span className="file-types">JPG, PNG, PDF</span>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}

            {/* Add Experience Button */}
            <div className="add-experience-wrapper full-width">
              <button
                type="button"
                className="add-experience-btn"
                onClick={addExperience}
                disabled={isSubmitting}
              >
                + Add Experience
              </button>
            </div>
          </>
        )}

        {/* Fresher Message */}
        {formData.experienceType === 'fresher' && (
          <div className="fresher-message">
            <p>You have selected Fresher. No experience details required.</p>
          </div>
        )}
      </div>

      {isOtpStep && (
        <div className="application-field otp-field full-width">
          <label htmlFor="otp">OTP Verification <span className="required-star">*</span></label>
          <input
            id="otp"
            name="otp"
            value={formData.otp}
            onChange={handleChange}
            placeholder="Enter OTP sent to your email"
            disabled={isSubmitting}
          />
          {formErrors.otp && <p className="application-error">{formErrors.otp}</p>}
        </div>
      )}
    </>
  );
};

export default Step4Experience;